module.exports = __webpack_public_path__ + "static/offer-m-1-c46240219a5cbaf10e4665b5e57e04c0.jpg";